import type { StaticRemote } from '@cosmica-shell-ui/shell-shared'

export const remotePlatformMap: StaticRemote[] = [
  {
    name: 'sky',
    entry: `${import.meta.env.VITE_CHATBOT_URL}/remoteEntry.js`, // URL del tuo MFE
    enabled: true
  }
]
